import { render, staticRenderFns } from "./EducationPatientHeader.vue?vue&type=template&id=71e92f41&scoped=true"
import script from "./EducationPatientHeader.vue?vue&type=script&lang=js"
export * from "./EducationPatientHeader.vue?vue&type=script&lang=js"
import style0 from "./EducationPatientHeader.vue?vue&type=style&index=0&id=71e92f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e92f41",
  null
  
)

export default component.exports